import React, { useContext } from "react";

import { storageHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";
import { SkeletonAnnotated } from "lib/components";

import { withErrorBoundary } from "lib/hoc";

import { useNavigate } from "react-router-dom";
import ChargebeeVendorPlan from "./subFeatures/chargebee";
import StripeVendorPlan from "./subFeatures/stripe";

const PlanView = (props) => {
  const { onSubmit = () => {}, submitLoading, error, banner, setBanner } = props;

  const currentUserRole = storageHelper.get("userRole");
  const { currentUser, isLoading, associatedSeller = {} } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { chargebee = {}, isChargebee = false, isStripeSubscription = false, stripeSubscription = {} } =
    associatedSeller || {};

  const isChargebeeEnabled = !!(isChargebee && chargebee);
  const isStripe = !!(isStripeSubscription && stripeSubscription && stripeSubscription.apiKey);

  if (!(isStripe || isChargebeeEnabled)) {
    return navigate("/");
  }

  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (isChargebeeEnabled) {
      return (
        <ChargebeeVendorPlan
          banner={banner}
          error={error}
          onSubmit={onSubmit}
          setBanner={setBanner}
          submitLoading={submitLoading}
        />
      );
    }
    if (isStripe) {
      return <StripeVendorPlan />;
    }

    return null;
  };

  const PlanView = getComponent(currentUserRole);
  return PlanView;
};

export default withErrorBoundary(PlanView);
